export const defaultStructure = {
  type: 'doc',
  attrs: {
    id: null,
    deletable: true,
    appliedThemeId: null,
    pageId: null,
    backgroundColor: 'inherit',
    data: {},
  },
  content: [
    {
      type: 'container',
      attrs: {
        id: '20489355-c46f-4992-a3de-5b799eeb268d',
        lp_name: '',
        deletable: true,
        tokens: {
          backgroundColor: 'background_color',
        },
        mergeTag: null,
        textAlign: 'center',
        width: '100%',
        stackOnMobile: true,
        borderRadius: '12px 12px 12px 12px',
        appliedThemeId: null,
        position: 'relative',
        top: '0px',
        left: '0px',
        right: '0px',
        bottom: '0px',
        positionTopActive: true,
        positionLeftActive: false,
        positionRightActive: true,
        positionBottomActive: false,
        centerHorizontally: false,
        centerVertically: false,
        flexDirection: 'column',
        mobileFlexDirection: 'column',
        backgroundColor: '#FFFFFFFF',
        overflow: 'hidden',
        shadow: 'none',
        blur: '0px',
        backgroundDarken: false,
        horizontalAlign: 'left',
        verticalAlign: 'align_start',
        width_max: '100%',
        mobilePadding: '16px 16px 16px 16px',
        padding: '16px 16px 16px 16px',
        margin: '0px 0px 0px 0px',
        gap: '12px',
        borderWidth: '1px',
        borderColor: '#E5E7EB',
        borderStyle: 'solid',
        flexWrap: 'nowrap',
      },
      content: [
        {
          type: 'heading',
          attrs: {
            id: '9b3346d3-f669-40f6-9932-c3eff8a67c2e',
            lp_name: 'Title',
            deletable: true,
            textAlign: 'center',
            tokens: {
              backgroundColor: 'background_color',
            },
            mergeTag: 'tag.display',
            width: '100%',
            maxWidth: '100%',
            appliedThemeId: null,
            level: 1,
            lineClampClass: '',
            backgroundColor: '#ffffff',
            borderRadius: '0px',
            borderWidth: '0px',
            borderColor: 'inherit',
            borderStyle: 'none',
            lineHeight: '100%',
            mobileLineHeight: '100%',
            padding: '0px 0px 0px 0px',
            mobilePadding: '0px 0px 0px 0px',
          },
          content: [
            {
              type: 'text',
              marks: [
                {
                  type: 'textStyle',
                  attrs: {
                    mobileFontSize: '16px',
                    fontSize: '16px',
                    fontWeight: '400',
                    fontGradient: null,
                    fontFamily: 'Libre Bodoni',
                    color: '#030712',
                    tokens: {},
                    appliedThemeId: null,
                  },
                },
              ],
              text: 'Beach',
            },
          ],
        },
        {
          type: 'paragraph',
          attrs: {
            id: '9dc0f95e-756d-43d9-8e52-de13dc7eaea1',
            lp_name: 'Description',
            deletable: true,
            textAlign: 'center',
            tokens: {
              backgroundColor: 'background_color',
            },
            mergeTag: 'tag.description',
            width: '100%',
            maxWidth: '100%',
            appliedThemeId: null,
            backgroundColor: '#ffffff',
            borderRadius: '0px',
            borderWidth: '0px',
            borderColor: 'inherit',
            borderStyle: 'none',
            lineClampClass: '',
            padding: '0px 0px 0px 0px',
            mobilePadding: '0px 0px 0px 0px',
            lineHeight: '120%',
            mobileLineHeight: '120%',
            margin: null,
            postAuthors: [],
            postAuthorsTruncateListEnabled: false,
            postAuthorsByLine: '',
            postTimestampDisplay: 'short_date',
            postReadTimeSuffix: 'min read',
            postTagsTruncateListEnabled: true,
          },
          content: [
            {
              type: 'text',
              marks: [
                {
                  type: 'textStyle',
                  attrs: {
                    mobileFontSize: '12px',
                    fontSize: '12px',
                    fontWeight: '400',
                    fontGradient: null,
                    fontFamily: 'Inter',
                    color: '#030712',
                    tokens: {},
                    appliedThemeId: null,
                  },
                },
              ],
              text: 'Relax by the waves with guides to the best beaches and coastal experiences.',
            },
          ],
        },
      ],
    },
  ],
};
